interface GithubSync {
  oid: string;
  task: Promise<void>;
}

const syncsDuplex = new TransformStream<GithubSync, GithubSync>();

const writer = syncsDuplex.writable.getWriter();
const reader = syncsDuplex.readable.getReader();

export const githubSyncs = {
  push(sync: GithubSync) {
    writer.write(sync);
  },
  next() {
    return reader.read();
  },
};
